import { Textarea } from '../../../ui/Textarea';
import type { QuestionDefinition } from '../../../../types/checkin';

interface TextareaQuestionProps {
  question: QuestionDefinition;
  value: string | undefined;
  onChange: (value: string) => void;
}

export function TextareaQuestion({
  question,
  value = '',
  onChange,
}: TextareaQuestionProps) {
  return (
    <Textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={question.placeholder}
      maxLength={question.maxLength}
      rows={question.rows || 4}
    />
  );
}
